var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.49817 1C9.26797 -0.333334 11.1925 -0.333333 11.9623 1L20.1895 15.25C20.9593 16.5833 19.9971 18.25 18.4575 18.25H2.00298C0.463383 18.25 -0.498867 16.5833 0.270933 15.25L8.49817 1Z",
    fill: "#FFC430"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4805 4.625L11.2227 12.5234H9.34766L9.08203 4.625H11.4805ZM9.01953 14.9688C9.01953 14.6354 9.13411 14.3594 9.36328 14.1406C9.59766 13.9167 9.90495 13.8047 10.2852 13.8047C10.6706 13.8047 10.9779 13.9167 11.207 14.1406C11.4362 14.3594 11.5508 14.6354 11.5508 14.9688C11.5508 15.2917 11.4362 15.5651 11.207 15.7891C10.9779 16.013 10.6706 16.125 10.2852 16.125C9.90495 16.125 9.59766 16.013 9.36328 15.7891C9.13411 15.5651 9.01953 15.2917 9.01953 14.9688Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/WarningIcon.dde5e12f16ca3d0470252e250aece844.svg";
export { ForwardRef as ReactComponent };